const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"organization_general_information_card":({"general_information":"General information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;